export const decodeJwt = (jwtString, fallbackValue) => {
  if (!jwtString) {
    return fallbackValue;
  }

  try {
    const [, base64Payload] = jwtString.split('.');
    const payload = atob(base64Payload);
    return JSON.parse(payload);
  } catch (err) {
    if (fallbackValue === undefined) {
      throw err;
    }
    return fallbackValue;
  }
};

/**
 * Maps `sortKeys` into a comma separated string that is used by `bonfire-global-api` in order
 * to support server-side sorting.
 * @example
 * const sortKeys = [
 *  { id: dateClose, direction: 'asc' },
 *  { id: dateOpen, direction: 'desc' },
 * ];
 *
 * sortKeysToQueryString(sortKeys); -> '+dateClose,-dateOpen'
 *
 * @param {Array<{id: string, direction: 'asc' | 'desc'}>} sortKeys The array of keys to sort by.
 * @returns {string} A comma separated string.
 */
export const sortKeysToQueryString = sortKeys => {
  if (!sortKeys || !sortKeys.length) return undefined;

  const directionsMap = { asc: '+', desc: '-' };

  return sortKeys
    .map(({ id, direction }) => {
      const directionCode = directionsMap[direction];

      if (!directionCode) {
        throw new Error(
          `Direction '${direction}' not allowed, direction value can only be 'asc' or 'desc`
        );
      }

      return `${directionCode}${id}`;
    })
    .join(',');
};
